"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TKpiMapLegendScaleType = exports.TKpiMapLegendType = exports.DEFAULT_DASHBOARD = exports.DASHBOARD_PROVIDER = exports.DB_TYPE = exports.HEATMAP_COLOR_PALETTE = exports.BUSINESS_TYPE = exports.HEATMAP_COLOR_TYPE = exports.PIVOT_TYPE = exports.QUERY_TYPE = exports.AGGREGATOR_DIMENSION = exports.LEGEND_DISPLAY_POSITION = exports.AGGREGATOR = exports.AXIS_TYPE = exports.KPI_TYPE = exports.DASHBOARD_SCOPE = exports.DASHBOARD_TYPE = void 0;
/**
 * Type of Dashboard
 */
var DASHBOARD_TYPE;
(function (DASHBOARD_TYPE) {
    DASHBOARD_TYPE["MOBILE"] = "MOBILE";
    DASHBOARD_TYPE["ON_LIST_ITEM"] = "ON_LIST_ITEM";
    /**
     * @deprecated This field will be deprecated on the next release, will be replaced by ON_LIST_ITEM
     */
    DASHBOARD_TYPE["MOBILE_ON_LIST"] = "MOBILE_ON_LIST";
    DASHBOARD_TYPE["MOBILE_ON_ACTIVITY"] = "MOBILE_ON_ACTIVITY";
    DASHBOARD_TYPE["WEB"] = "WEB";
    DASHBOARD_TYPE["MOBILE_AND_WEB"] = "MOBILE_AND_WEB";
})(DASHBOARD_TYPE || (exports.DASHBOARD_TYPE = DASHBOARD_TYPE = {}));
/**
 * Dashboard scope
 */
var DASHBOARD_SCOPE;
(function (DASHBOARD_SCOPE) {
    DASHBOARD_SCOPE["GLOBAL"] = "GLOBAL";
    DASHBOARD_SCOPE["TEAM"] = "TEAM";
})(DASHBOARD_SCOPE || (exports.DASHBOARD_SCOPE = DASHBOARD_SCOPE = {}));
/**
 * Type of KPI
 */
var KPI_TYPE;
(function (KPI_TYPE) {
    KPI_TYPE["LINE_CHART"] = "LINE_CHART";
    KPI_TYPE["SCORECARD"] = "SCORECARD";
    KPI_TYPE["GAUGE"] = "GAUGE";
    KPI_TYPE["PIE_CHART"] = "PIE_CHART";
    KPI_TYPE["BAR_CHART"] = "BAR_CHART";
    KPI_TYPE["BAR_CHART_HORIZONTAL"] = "BAR_CHART_HORIZONTAL";
    KPI_TYPE["STACKED_BAR_CHART"] = "STACKED_BAR_CHART";
    KPI_TYPE["GROUPED_BAR_CHART"] = "GROUPED_BAR_CHART";
    KPI_TYPE["MULTIPLE_LINE_CHART"] = "MULTIPLE_LINE_CHART";
    KPI_TYPE["HEATMAP_CHART"] = "HEATMAP_CHART";
    KPI_TYPE["CALENDAR_CHART"] = "CALENDAR_CHART";
    KPI_TYPE["SCATTER_PLOT_CHART"] = "SCATTER_PLOT_CHART";
    KPI_TYPE["MAP"] = "MAP";
    KPI_TYPE["TABLE"] = "TABLE";
    KPI_TYPE["MATRIX"] = "MATRIX";
    KPI_TYPE["CAROUSEL"] = "CAROUSEL";
    KPI_TYPE["TIMELINE"] = "TIMELINE";
    KPI_TYPE["HISTOGRAM"] = "HISTOGRAM";
    KPI_TYPE["CUSTOMERS_MAP"] = "CUSTOMERS_MAP";
})(KPI_TYPE || (exports.KPI_TYPE = KPI_TYPE = {}));
/**
 * Type of the axis
 */
var AXIS_TYPE;
(function (AXIS_TYPE) {
    AXIS_TYPE["TEXT"] = "TEXT";
    AXIS_TYPE["TIME"] = "TIME";
    AXIS_TYPE["NUMBER"] = "NUMBER";
})(AXIS_TYPE || (exports.AXIS_TYPE = AXIS_TYPE = {}));
/**
 * Aggregator operation
 */
var AGGREGATOR;
(function (AGGREGATOR) {
    AGGREGATOR["SUM"] = "SUM";
    AGGREGATOR["MEAN"] = "MEAN";
    AGGREGATOR["MIN"] = "MIN";
    AGGREGATOR["MAX"] = "MAX";
    AGGREGATOR["NONE"] = "NONE";
    AGGREGATOR["BOOLEAN"] = "BOOLEAN";
    AGGREGATOR["PERCENTAGE"] = "PERCENTAGE";
    AGGREGATOR["COUNT"] = "COUNT";
    AGGREGATOR["COUNT_DISTINCT"] = "COUNT_DISTINCT";
})(AGGREGATOR || (exports.AGGREGATOR = AGGREGATOR = {}));
var LEGEND_DISPLAY_POSITION;
(function (LEGEND_DISPLAY_POSITION) {
    LEGEND_DISPLAY_POSITION["AS_ARC_ON_CHART"] = "as-arc-on-chart";
    LEGEND_DISPLAY_POSITION["TOP_LEFT"] = "top-left";
    LEGEND_DISPLAY_POSITION["LEFT"] = "left";
    LEGEND_DISPLAY_POSITION["BOTTOM_LEFT"] = "bottom-left";
    LEGEND_DISPLAY_POSITION["TOP_RIGHT"] = "top-right";
    LEGEND_DISPLAY_POSITION["RIGHT"] = "right";
    LEGEND_DISPLAY_POSITION["BOTTOM_RIGHT"] = "bottom-right";
    LEGEND_DISPLAY_POSITION["BOTTOM"] = "bottom";
})(LEGEND_DISPLAY_POSITION || (exports.LEGEND_DISPLAY_POSITION = LEGEND_DISPLAY_POSITION = {}));
var AGGREGATOR_DIMENSION;
(function (AGGREGATOR_DIMENSION) {
    AGGREGATOR_DIMENSION["COLUMN"] = "COLUMN";
    AGGREGATOR_DIMENSION["ROW"] = "ROW";
})(AGGREGATOR_DIMENSION || (exports.AGGREGATOR_DIMENSION = AGGREGATOR_DIMENSION = {}));
/**
 * Type of the subquery (for TABLE type) => not used yet
 */
var QUERY_TYPE;
(function (QUERY_TYPE) {
    QUERY_TYPE["NUMERIC"] = "NUMERIC";
    QUERY_TYPE["TEXT"] = "TEXT";
    QUERY_TYPE["PERCENTAGE"] = "PERCENTAGE";
})(QUERY_TYPE || (exports.QUERY_TYPE = QUERY_TYPE = {}));
var PIVOT_TYPE;
(function (PIVOT_TYPE) {
    PIVOT_TYPE["MOBILE_USER"] = "MOBILE_USER";
    PIVOT_TYPE["TEAM"] = "TEAM";
    PIVOT_TYPE["DATE"] = "DATE";
    PIVOT_TYPE["CUSTOM"] = "CUSTOM";
    PIVOT_TYPE["NONE"] = "NONE";
})(PIVOT_TYPE || (exports.PIVOT_TYPE = PIVOT_TYPE = {}));
var HEATMAP_COLOR_TYPE;
(function (HEATMAP_COLOR_TYPE) {
    HEATMAP_COLOR_TYPE["sequential"] = "sequential";
    HEATMAP_COLOR_TYPE["diverging"] = "diverging";
    HEATMAP_COLOR_TYPE["quantize"] = "quantize";
})(HEATMAP_COLOR_TYPE || (exports.HEATMAP_COLOR_TYPE = HEATMAP_COLOR_TYPE = {}));
var BUSINESS_TYPE;
(function (BUSINESS_TYPE) {
    BUSINESS_TYPE["STATEMENT"] = "STATEMENT";
    BUSINESS_TYPE["ROUTE_MGT_LOADING_GUIDE"] = "ROUTE_MGT_LOADING_GUIDE";
    BUSINESS_TYPE["ACTIVITY_GUIDE"] = "ACTIVITY_GUIDE";
})(BUSINESS_TYPE || (exports.BUSINESS_TYPE = BUSINESS_TYPE = {}));
var HEATMAP_COLOR_PALETTE;
(function (HEATMAP_COLOR_PALETTE) {
    HEATMAP_COLOR_PALETTE["default"] = "default";
    HEATMAP_COLOR_PALETTE["brown_blueGreen"] = "brown_blueGreen";
    HEATMAP_COLOR_PALETTE["purpleRed_green"] = "purpleRed_green";
    HEATMAP_COLOR_PALETTE["pink_yellowGreen"] = "pink_yellowGreen";
    HEATMAP_COLOR_PALETTE["purple_orange"] = "purple_orange";
    HEATMAP_COLOR_PALETTE["red_blue"] = "red_blue";
    HEATMAP_COLOR_PALETTE["red_grey"] = "red_grey";
    HEATMAP_COLOR_PALETTE["red_yellow_blue"] = "red_yellow_blue";
    HEATMAP_COLOR_PALETTE["red_yellow_green"] = "red_yellow_green";
    HEATMAP_COLOR_PALETTE["spectral"] = "spectral";
    HEATMAP_COLOR_PALETTE["blues"] = "blues";
    HEATMAP_COLOR_PALETTE["greens"] = "greens";
    HEATMAP_COLOR_PALETTE["greys"] = "greys";
    HEATMAP_COLOR_PALETTE["oranges"] = "oranges";
    HEATMAP_COLOR_PALETTE["purples"] = "purples";
    HEATMAP_COLOR_PALETTE["reds"] = "reds";
    HEATMAP_COLOR_PALETTE["turbo"] = "turbo";
    HEATMAP_COLOR_PALETTE["viridis"] = "viridis";
    HEATMAP_COLOR_PALETTE["inferno"] = "inferno";
    HEATMAP_COLOR_PALETTE["magma"] = "magma";
    HEATMAP_COLOR_PALETTE["plasma"] = "plasma";
    HEATMAP_COLOR_PALETTE["cividis"] = "cividis";
    HEATMAP_COLOR_PALETTE["warm"] = "warm";
    HEATMAP_COLOR_PALETTE["cool"] = "cool";
    HEATMAP_COLOR_PALETTE["cubehelixDefault"] = "cubehelixDefault";
    HEATMAP_COLOR_PALETTE["blue_green"] = "blue_green";
    HEATMAP_COLOR_PALETTE["blue_purple"] = "blue_purple";
    HEATMAP_COLOR_PALETTE["green_blue"] = "green_blue";
    HEATMAP_COLOR_PALETTE["orange_red"] = "orange_red";
    HEATMAP_COLOR_PALETTE["purple_blue_green"] = "purple_blue_green";
    HEATMAP_COLOR_PALETTE["purple_blue"] = "purple_blue";
    HEATMAP_COLOR_PALETTE["purple_red"] = "purple_red";
    HEATMAP_COLOR_PALETTE["red_purple"] = "red_purple";
    HEATMAP_COLOR_PALETTE["yellow_green_blue"] = "yellow_green_blue";
    HEATMAP_COLOR_PALETTE["yellow_green"] = "yellow_green";
    HEATMAP_COLOR_PALETTE["yellow_orange_brown"] = "yellow_orange_brown";
    HEATMAP_COLOR_PALETTE["yellow_orange_red"] = "yellow_orange_red";
    HEATMAP_COLOR_PALETTE["rainbow"] = "rainbow";
    HEATMAP_COLOR_PALETTE["sinebow"] = "sinebow";
})(HEATMAP_COLOR_PALETTE || (exports.HEATMAP_COLOR_PALETTE = HEATMAP_COLOR_PALETTE = {}));
var DB_TYPE;
(function (DB_TYPE) {
    DB_TYPE["POSTGRES"] = "POSTGRES";
    DB_TYPE["MSSQL"] = "MSSQL";
    DB_TYPE["OPTIMETRIKS"] = "OPTIMETRIKS";
    DB_TYPE["BIGQUERY"] = "BIGQUERY";
})(DB_TYPE || (exports.DB_TYPE = DB_TYPE = {}));
var DASHBOARD_PROVIDER;
(function (DASHBOARD_PROVIDER) {
    DASHBOARD_PROVIDER["SUPERSET"] = "SUPERSET";
    DASHBOARD_PROVIDER["OPTIMETRIKS"] = "OPTIMETRIKS";
})(DASHBOARD_PROVIDER || (exports.DASHBOARD_PROVIDER = DASHBOARD_PROVIDER = {}));
var DEFAULT_DASHBOARD;
(function (DEFAULT_DASHBOARD) {
    DEFAULT_DASHBOARD["GPS_TRACKING"] = "_gps_tracking";
    DEFAULT_DASHBOARD["RECAP_REPORT"] = "_recap_report";
    DEFAULT_DASHBOARD["FREE_TRIAL_USER"] = "_free_trial_user";
    DEFAULT_DASHBOARD["MONTHLY_SUBMISSIONS"] = "_monthly_submissions";
    DEFAULT_DASHBOARD["WEEKLY_SUBMISSIONS"] = "_weekly_submissions";
    DEFAULT_DASHBOARD["LOG_REPORT"] = "_log_report";
    DEFAULT_DASHBOARD["LIST_ANALYSIS"] = "_list_analysis";
    DEFAULT_DASHBOARD["TEAM_ANALYSIS"] = "_team_analysis";
    DEFAULT_DASHBOARD["MASTER_USER_LIST"] = "_master_user_list";
    DEFAULT_DASHBOARD["BILLING_REPORT"] = "_billing_report";
    DEFAULT_DASHBOARD["USAGE"] = "_usage";
    DEFAULT_DASHBOARD["USAGE_PER_CLIENT"] = "_usage_per_client";
    DEFAULT_DASHBOARD["FEATURE_DASHBOARD"] = "_feature_dashboard";
    DEFAULT_DASHBOARD["PILOT_REPORT"] = "_pilot_report";
    DEFAULT_DASHBOARD["MONTHLY_CLIENT"] = "_monthly_client";
    DEFAULT_DASHBOARD["PIECHART_DISTRIBUTION_REPORT"] = "_piechart_distribution_report";
})(DEFAULT_DASHBOARD || (exports.DEFAULT_DASHBOARD = DEFAULT_DASHBOARD = {}));
var TKpiMapLegendType;
(function (TKpiMapLegendType) {
    /**
     * @deprecated
     */
    TKpiMapLegendType["LINEAR"] = "LINEAR";
    /**
     * @deprecated
     */
    TKpiMapLegendType["SCALE"] = "SCALE";
    TKpiMapLegendType["GRADIENT"] = "GRADIENT";
    TKpiMapLegendType["CATEGORIES"] = "CATEGORIES";
})(TKpiMapLegendType || (exports.TKpiMapLegendType = TKpiMapLegendType = {}));
/**
 * @deprecated Unused will be removed in the next release
 */
var TKpiMapLegendScaleType;
(function (TKpiMapLegendScaleType) {
    TKpiMapLegendScaleType["LINEAR"] = "LINEAR";
})(TKpiMapLegendScaleType || (exports.TKpiMapLegendScaleType = TKpiMapLegendScaleType = {}));
